import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setAccessType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const AccessTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Access"
      id="access_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setAccessType(option.id))
      }}
    />
  )
}
export default AccessTypeDropdown
